import { fetchFundingRatePoints } from '$lib/apis/fundingRate';
import {
	currentMarketIdentifier,
	loadingMarketTimeSeriesPoints,
	marketTimeSeriesPoints,
	marketTimeSeriesRange
} from '$lib/home/store';
import type {
	MarketIdentifiers,
	MarketTimeseriesPoint,
	MarketTimeseriesRangeOption
} from '$lib/types/market';
import { getPastTimestampInMillisecondsDeltaDaysOrMonths } from '$lib/util/util';
import { get } from 'svelte/store';

export async function getMarketTimeSeriesPoints(
	marketIdentifier: MarketIdentifiers,
	range: MarketTimeseriesRangeOption
) {
	loadingMarketTimeSeriesPoints.set(true);
	let endTimestamp: number = Date.now();
	let startTimestamp: number = getPastTimestampInMillisecondsDeltaDaysOrMonths(1, 0);
	if (range == '1W') startTimestamp = getPastTimestampInMillisecondsDeltaDaysOrMonths(7, 0);
	else if (range == '1M') startTimestamp = getPastTimestampInMillisecondsDeltaDaysOrMonths(0, 1);

	const data = await fetchFundingRatePoints(marketIdentifier, startTimestamp, endTimestamp);
	const pointsData: Array<MarketTimeseriesPoint> = data.timeSeriesData;
	marketTimeSeriesPoints.set(pointsData);
	loadingMarketTimeSeriesPoints.set(false);
}

export async function getCurrentMarketTimeSeriesPoints() {
	if (get(currentMarketIdentifier) && get(marketTimeSeriesRange)) {
		await getMarketTimeSeriesPoints(get(currentMarketIdentifier), get(marketTimeSeriesRange));
	}
}
